/* =========================================================
   Aloha Sun · theme JS
   ========================================================= */

/* === Mahalo editorial render === */
(function renderEditorial(){
  const editorial = document.getElementById('editorial');
  if (editorial && editorial.dataset.dynamicArticle === 'true') return;
  const POSTS = window.MAHALO_POSTS || [];
  const p = POSTS[0]; if (!p) return;
  const art = document.getElementById('magArt');
  if (art) art.style.background = p.coverGradient;
  const set = (id, fn) => { const el = document.getElementById(id); if (el) fn(el); };
  set('magCover',  el => el.innerHTML = p.cover);
  set('magIssue',  el => el.textContent = 'Mahalo Magazine · ' + p.issue);
  set('magHead',   el => el.innerHTML = p.title);
  set('magDek',    el => el.textContent = p.dek);
  set('magDek2',   el => el.textContent = p.dek2 || '');
  set('magByline', el => el.textContent = [p.byline, p.date, p.readTime].filter(Boolean).join(' · '));
  set('magCta',    el => { el.setAttribute('href', p.url); el.innerHTML = (p.cta || 'Read the issue') + ' <span class="arrow">→</span>'; });
})();

/* Keep legacy About page HTML launch-safe until its business facts are verified. */
(function aboutPageGuardrails(){
  if (!/^\/pages\/about\/?$/.test(window.location.pathname)) return;
  document.querySelectorAll('.fu-hero .meta-row, .fu-about-stats').forEach(el => el.remove());
  document.querySelectorAll('.fu-contact .channels a[href^="tel:"]').forEach(link => {
    if (/555[-\s]?1823/.test(link.textContent)) link.remove();
  });
  const contactCopy = document.querySelector('.fu-contact-inner > div:first-child > p');
  if (contactCopy) contactCopy.textContent = 'Questions about products, orders, wholesale, press, or partnerships? Send a message and the Aloha Sun team will follow up.';
})();

/* === Age gate (session-only) === */
const ageGate = document.getElementById('ageGate');
if (ageGate) {
  const rememberAge = ageGate.dataset.remember !== 'false';
  const yes = document.getElementById('ageYes');
  const no  = document.getElementById('ageNo');
  const hideAgeGate = () => {
    ageGate.classList.add('hidden');
    ageGate.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('age-gate-open');
  };
  if (rememberAge && sessionStorage.getItem('aloha-age') === 'ok') {
    hideAgeGate();
  } else {
    ageGate.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('age-gate-open');
    setTimeout(() => yes && yes.focus(), 0);
  }
  if (yes) yes.addEventListener('click', () => { if (rememberAge) sessionStorage.setItem('aloha-age', 'ok'); hideAgeGate(); });
  if (no) no.addEventListener('click', () => {
    document.querySelector('.age-gate-inner').innerHTML =
      '<h2 style="margin-bottom:8px;">Mahalo for your honesty.</h2>' +
      '<p>This site is for adults 21+. We hope to see you when you\u2019re older.</p>';
  });
}

/* === Hawaiian fish cursor on age gate === */
(function fishCursor(){
  const gate = document.getElementById('ageGate');
  const canvas = document.getElementById('ageGateFishCanvas');
  if (!gate || !canvas || gate.classList.contains('hidden')) return;
  const ctx = canvas.getContext('2d');
  const PRM = matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (PRM) return;

  function resize(){
    const r = gate.getBoundingClientRect();
    canvas.width = r.width; canvas.height = r.height;
  }
  resize();
  window.addEventListener('resize', resize);

  const FISH_KINDS = [
    { body:'#FFD60A', stripe:'#1a1413' },
    { body:'#FF7A1A', stripe:'#FFF1B8' },
    { body:'#00C2E0', stripe:'#FF4D8B' },
    { body:'#A05CE0', stripe:'#FFD60A' },
    { body:'#00D38A', stripe:'#FF2E4C' },
    { body:'#FF4D8B', stripe:'#FFF1B8' }
  ];

  const N = 18;
  const cursor = { x: canvas.width/2, y: canvas.height/2 };
  const followRange = 99999; // all fish eventually follow the cursor

  function Fish(i){
    this.x = Math.random()*canvas.width;
    this.y = canvas.height*0.25 + Math.random()*canvas.height*0.7;
    this.vx = (Math.random()-.5)*1.2;
    this.vy = (Math.random()-.5)*0.6;
    this.angle = 0;
    this.size = 8 + Math.random()*6;
    this.kind = FISH_KINDS[i % FISH_KINDS.length];
    this.wanderA = Math.random()*Math.PI*2;
    this.tail = Math.random()*Math.PI*2;
    this.following = false;
    this.target = null;
  }
  const fish = []; for (let i=0;i<N;i++) fish.push(new Fish(i));

  function onMove(e){
    const r = canvas.getBoundingClientRect();
    cursor.x = e.clientX - r.left; cursor.y = e.clientY - r.top;
  }
  function onTouch(e){
    if (!e.touches[0]) return;
    const r = canvas.getBoundingClientRect();
    cursor.x = e.touches[0].clientX - r.left; cursor.y = e.touches[0].clientY - r.top;
  }
  gate.addEventListener('mousemove', onMove);
  gate.addEventListener('touchmove', onTouch, {passive:true});
  gate.addEventListener('touchstart', onTouch, {passive:true});

  function step(){
    if (gate.classList.contains('hidden')) return;
    ctx.clearRect(0,0,canvas.width,canvas.height);

    fish.forEach(f => { f.following = false; f.target = null; });
    const followingFish = [];
    let closest = null, closestD = Infinity;
    fish.forEach(f => {
      const d = Math.hypot(f.x-cursor.x, f.y-cursor.y);
      if (d < followRange && d < closestD) { closestD = d; closest = f; }
    });
    if (closest) { closest.following = true; closest.target = cursor; followingFish.push(closest); }
    let added = true;
    while (added){
      added = false;
      fish.forEach(f => {
        if (f.following) return;
        let nd = Infinity, na = null;
        followingFish.forEach(g => { const d = Math.hypot(f.x-g.x, f.y-g.y); if (d<nd){ nd=d; na=g; } });
        if (nd < followRange && na){ f.following=true; f.target={x:na.x,y:na.y}; followingFish.push(f); added=true; }
      });
    }

    fish.forEach(f => {
      if (f.following && f.target){
        const dx = f.target.x - f.x, dy = f.target.y - f.y, d = Math.hypot(dx,dy);
        if (d > 6){
          const ta = Math.atan2(dy,dx);
          let diff = ta - f.angle;
          while(diff>Math.PI) diff-=Math.PI*2;
          while(diff<-Math.PI) diff+=Math.PI*2;
          f.angle += diff*0.2;
          const sp = Math.min(2.4, d*0.12);
          f.vx += (Math.cos(f.angle)*sp - f.vx)*0.15;
          f.vy += (Math.sin(f.angle)*sp - f.vy)*0.15;
        } else { f.vx*=0.85; f.vy*=0.85; }
      } else {
        f.wanderA += (Math.random()-.5)*0.18;
        const tvx = Math.cos(f.wanderA)*0.7, tvy = Math.sin(f.wanderA)*0.35;
        f.vx += (tvx - f.vx)*0.04;
        f.vy += (tvy - f.vy)*0.04;
        if (f.x < 24) f.wanderA = 0;
        if (f.x > canvas.width-24) f.wanderA = Math.PI;
        if (f.y < 24) f.wanderA = Math.PI/2;
        if (f.y > canvas.height-24) f.wanderA = -Math.PI/2;
      }
      f.x += f.vx; f.y += f.vy;
      f.x = Math.max(6, Math.min(canvas.width-6, f.x));
      f.y = Math.max(6, Math.min(canvas.height-6, f.y));
      const sp = Math.hypot(f.vx,f.vy);
      if (sp > 0.1) f.angle = Math.atan2(f.vy, f.vx);
      f.tail += sp*0.4 + 0.08;

      ctx.save();
      ctx.translate(f.x, f.y);
      ctx.rotate(f.angle);
      const flip = Math.cos(f.angle) < 0 ? -1 : 1;
      ctx.scale(1, flip);
      const s = f.size;
      ctx.fillStyle = f.kind.body;
      ctx.beginPath(); ctx.ellipse(0, 0, s, s*0.55, 0, 0, Math.PI*2); ctx.fill();
      ctx.fillStyle = f.kind.stripe;
      ctx.beginPath(); ctx.ellipse(s*0.1, 0, s*0.18, s*0.45, 0, 0, Math.PI*2); ctx.fill();
      const tw = Math.sin(f.tail)*0.4;
      ctx.fillStyle = f.kind.body;
      ctx.beginPath();
      ctx.moveTo(-s*0.85, 0);
      ctx.lineTo(-s*1.55, -s*0.55 + tw*s*0.2);
      ctx.lineTo(-s*1.55,  s*0.55 + tw*s*0.2);
      ctx.closePath(); ctx.fill();
      ctx.beginPath();
      ctx.moveTo(-s*0.2, -s*0.5);
      ctx.lineTo( s*0.1, -s*0.95);
      ctx.lineTo( s*0.35,-s*0.5);
      ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#fff';
      ctx.beginPath(); ctx.arc(s*0.55, -s*0.1, s*0.13, 0, Math.PI*2); ctx.fill();
      ctx.fillStyle = '#1a1413';
      ctx.beginPath(); ctx.arc(s*0.6, -s*0.1, s*0.07, 0, Math.PI*2); ctx.fill();
      ctx.restore();
    });
    requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
})();

/* =========================================================
   CART · Shopify AJAX
   ========================================================= */
const cartDrawer  = document.getElementById('cartDrawer');
const cartOverlay = document.getElementById('cartOverlay');
const cartItems   = document.getElementById('cartItems');
const cartTotal   = document.getElementById('cartTotal');
const cartCount   = document.getElementById('cartCount');

function moneyFmt(c){ return '$' + (c/100).toFixed(2); }

let cartReturnFocus = null;
function openCart(){
  cartReturnFocus = document.activeElement;
  if (cartDrawer) { cartDrawer.classList.add('open'); cartDrawer.setAttribute('aria-hidden', 'false'); cartDrawer.focus(); }
  if (cartOverlay) { cartOverlay.classList.add('open'); cartOverlay.setAttribute('aria-hidden', 'false'); }
  if (openCartBtn) openCartBtn.setAttribute('aria-expanded', 'true');
  document.documentElement.classList.add('cart-drawer-open');
}
function closeCart(){
  if (cartDrawer) { cartDrawer.classList.remove('open'); cartDrawer.setAttribute('aria-hidden', 'true'); }
  if (cartOverlay) { cartOverlay.classList.remove('open'); cartOverlay.setAttribute('aria-hidden', 'true'); }
  if (openCartBtn) openCartBtn.setAttribute('aria-expanded', 'false');
  document.documentElement.classList.remove('cart-drawer-open');
  if (cartReturnFocus && typeof cartReturnFocus.focus === 'function') cartReturnFocus.focus();
}

function renderCart(cart){
  if (!cart) return;
  if (cartCount) cartCount.textContent = cart.item_count || 0;
  document.querySelectorAll('[data-cart-count]').forEach(el => el.textContent = cart.item_count || 0);
  if (cartTotal) cartTotal.textContent = moneyFmt(cart.total_price || 0);
  if (!cartItems) return;
  if (!cart.items || !cart.items.length){
    cartItems.innerHTML = '<div class="cart-empty">Nothing here yet — paradise awaits.</div>';
    return;
  }
  cartItems.innerHTML = cart.items.map(i => {
    const title = (i.product_title || i.title).replace(/^Kalos · /,'').replace(/^Aloha Sun · /,'');
    const variant = (i.variant_title && i.variant_title !== 'Default Title') ? ' · ' + i.variant_title : '';
    const meta = (i.vendor || '') + variant + ' · ' + moneyFmt(i.final_price);
    const img = i.image ? `background:url(${i.image}) center/cover` : 'background:#FF7A1A';
    return `<div class="cart-item" data-key="${i.key}">
      <div class="swatch" style="${img}"></div>
      <div>
        <div class="nm">${title}</div>
        <div class="meta">${meta}</div>
        <div class="qty-mini">
          <button type="button" data-cart-qty="${i.key}" data-qty="${Math.max(0,i.quantity-1)}" aria-label="Decrease">−</button>
          <span>${i.quantity}</span>
          <button type="button" data-cart-qty="${i.key}" data-qty="${i.quantity+1}" aria-label="Increase">+</button>
        </div>
      </div>
      <div class="qty">${moneyFmt(i.final_line_price)}</div>
      <button class="ci-remove" type="button" data-cart-qty="${i.key}" data-qty="0" aria-label="Remove">×</button>
    </div>`;
  }).join('');
}

async function refreshCart(){
  try { const r = await fetch('/cart.js', { headers:{'Accept':'application/json'} }); if (r.ok) renderCart(await r.json()); }
  catch(e){}
}

async function changeCart(key, qty){
  try {
    const r = await fetch('/cart/change.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({ id: key, quantity: qty })
    });
    if (r.ok) renderCart(await r.json());
  } catch(e){}
}

async function addVariant(variantId, quantity, sellingPlan){
  if (!variantId) return false;
  const body = { id: variantId, quantity: quantity || 1 };
  if (sellingPlan) body.selling_plan = sellingPlan;
  try {
    const r = await fetch('/cart/add.js', {
      method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify(body)
    });
    if (!r.ok) return false;
    await r.json();
    await refreshCart();
    return true;
  } catch(e){ return false; }
}

const openCartBtn = document.getElementById('openCart');
const closeCartBtn = document.getElementById('closeCart');
if (openCartBtn)  openCartBtn.addEventListener('click', () => { openCart(); refreshCart(); });
if (closeCartBtn) closeCartBtn.addEventListener('click', closeCart);
if (cartOverlay)  cartOverlay.addEventListener('click', closeCart);
document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) closeCart(); });

if (cartItems) {
  cartItems.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    changeCart(btn.dataset.cartQty, parseInt(btn.dataset.qty, 10));
  });
}

refreshCart();

/* === Hero CTA add (legacy [data-add]) === */
document.querySelectorAll('[data-add]').forEach(btn => {
  btn.addEventListener('click', async (e) => {
    const variantId = btn.dataset.variantId;
    if (variantId && /^\d+$/.test(variantId)) {
      e.preventDefault();
      const ok = await addVariant(variantId, 1);
      if (ok) openCart();
    }
  });
});

/* === Product card add → open drawer === */
document.querySelectorAll('.product').forEach(p => {
  const btn = p.querySelector('[data-add-to-cart]');
  const pop = p.querySelector('.added-pop');
  if (!btn) return;
  btn.addEventListener('click', async (e) => {
    e.preventDefault(); e.stopPropagation();
    const variantId = p.dataset.variantId || btn.dataset.variantId;
    if (variantId && /^\d+$/.test(variantId)) {
      const ok = await addVariant(variantId, 1);
      if (ok) {
        if (pop) { pop.classList.add('show'); setTimeout(()=>pop.classList.remove('show'),1400); }
        openCart();
      }
    }
  });
});

/* Make whole product card clickable to product page */
document.querySelectorAll('.product[data-href]').forEach(p => {
  const href = p.dataset.href;
  if (!href || href === '#') return;
  p.style.cursor = 'pointer';
  const isInteractive = (target) => target.closest('a,button,input,select,textarea,form');
  p.addEventListener('click', (e) => { if (isInteractive(e.target)) return; window.location.href = href; });
  p.addEventListener('keydown', (e) => {
    if ((e.key === 'Enter' || e.key === ' ') && !isInteractive(e.target)) {
      e.preventDefault();
      window.location.href = href;
    }
  });
});

/* === PDP form: AJAX submit + variant reactive === */
(function pdpInit(){
  const form = document.getElementById('pdpForm');
  if (!form) return;
  const select = document.getElementById('pdpVariantSelect');
  const priceEl = document.getElementById('pdpPrice');
  const addPriceEl = document.getElementById('pdpAddPrice');
  const addBtn = document.getElementById('pdpAdd');
  const payment = form.querySelector('.pdp-payment');
  const qtyInput = document.getElementById('pdpQty');
  const vis = document.getElementById('pdpVis');
  const visImg = document.getElementById('pdpVisImg');
  const thumbs = Array.from(document.querySelectorAll('[data-pdp-image]'));

  function selectedSellingPlan(){
    const checked = form.querySelector('input[name="selling_plan"]:checked');
    return checked && checked.value ? checked.value : '';
  }

  function syncPurchaseOptions(){
    form.querySelectorAll('.pdp-purchase-choice').forEach(choice => {
      const input = choice.querySelector('input[name="selling_plan"]');
      choice.classList.toggle('is-active', !!(input && input.checked));
    });
  }

  function setPdpImage(src, alt){
    if (!visImg || !src) return;
    visImg.src = src;
    if (alt) visImg.alt = alt;
    thumbs.forEach(btn => btn.classList.toggle('is-active', btn.dataset.pdpImage === src));
  }

  function selectedQuantity(){
    if (!qtyInput) return 1;
    const qty = parseInt(qtyInput.value, 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  function splitDescriptionSpecs(){
    const infoGrid = document.querySelector('.pdp-info-grid');
    if (!infoGrid || infoGrid.querySelector('.pdp-specs')) return;
    const detailsRte = infoGrid.querySelector('.pdp-panel .rte');
    if (!detailsRte) return;
    const marker = Array.from(detailsRte.querySelectorAll('h2,h3,h4,p,strong')).find(el => /product specifications|specifications/i.test(el.textContent || ''));
    if (!marker) return;
    let start = marker.closest('h2,h3,h4,p') || marker;
    const panel = document.createElement('details');
    panel.className = 'pdp-panel pdp-spec-copy';
    panel.open = true;
    panel.innerHTML = '<summary><span>Product specifications</span></summary><div class="rte"></div>';
    const target = panel.querySelector('.rte');
    while (start) {
      const next = start.nextElementSibling;
      target.appendChild(start);
      start = next;
    }
    infoGrid.appendChild(panel);
    infoGrid.classList.remove('pdp-info-grid--single');
  }

  function findVariant(){
    if (!select) return null;
    const opts = Array.from(form.querySelectorAll('input[type=radio][name^="options["]:checked')).map(r => r.value);
    if (!opts.length) return select.options[select.selectedIndex];
    // match by option titles in select
    let match = null;
    Array.from(select.options).forEach(o => {
      const parts = (o.textContent || '').split(' / ').map(s => s.trim());
      const hit = opts.every(v => parts.includes(v));
      if (hit) match = o;
    });
    return match || select.options[0];
  }

  function syncFromSelected(){
    const opt = findVariant(); if (!opt) return;
    select.value = opt.value;
    const price = parseInt(opt.dataset.price, 10);
    const available = opt.dataset.available === 'true';
    if (priceEl && !isNaN(price)) priceEl.textContent = moneyFmt(price);
    if (addPriceEl && !isNaN(price)) addPriceEl.textContent = moneyFmt(price);
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.firstChild.textContent = available ? 'Add to cart — ' : 'Sold out — ';
    }
    if (payment) payment.hidden = !available;
    if (opt.dataset.image && opt.dataset.image !== '') setPdpImage(opt.dataset.image, visImg ? visImg.alt : '');
    // active swatch class
    form.querySelectorAll('.pdp-swatch').forEach(s => {
      const r = s.querySelector('input[type=radio]');
      s.classList.toggle('is-active', r && r.checked);
    });
    syncPurchaseOptions();
  }

  form.querySelectorAll('input[type=radio][name^="options["]').forEach(r => r.addEventListener('change', syncFromSelected));
  form.querySelectorAll('input[name="selling_plan"]').forEach(r => r.addEventListener('change', syncPurchaseOptions));
  form.querySelectorAll('[data-pdp-qty-step]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (!qtyInput) return;
      const next = selectedQuantity() + parseInt(btn.dataset.pdpQtyStep || '0', 10);
      qtyInput.value = Math.max(1, next);
    });
  });
  thumbs.forEach(btn => btn.addEventListener('click', () => setPdpImage(btn.dataset.pdpImage, btn.dataset.pdpAlt || '')));
  splitDescriptionSpecs();
  if (vis) {
    vis.addEventListener('pointermove', e => {
      const r = vis.getBoundingClientRect();
      const x = ((e.clientX - r.left) / r.width) * 100;
      const y = ((e.clientY - r.top) / r.height) * 100;
      vis.style.setProperty('--mx', x + '%');
      vis.style.setProperty('--my', y + '%');
      vis.style.setProperty('--pdx', ((x - 50) * 0.08) + 'px');
      vis.style.setProperty('--pdy', ((y - 50) * 0.08) + 'px');
    });
    vis.addEventListener('pointerleave', () => {
      vis.style.setProperty('--mx', '50%');
      vis.style.setProperty('--my', '42%');
      vis.style.setProperty('--pdx', '0');
      vis.style.setProperty('--pdy', '0');
    });
  }
  syncFromSelected();

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const opt = findVariant(); if (!opt) return;
    if (opt.dataset.available !== 'true') return;
    const orig = addBtn.innerHTML;
    addBtn.disabled = true;
    const ok = await addVariant(opt.value, selectedQuantity(), selectedSellingPlan());
    if (ok) {
      addBtn.innerHTML = 'Added \u2713';
      setTimeout(() => { addBtn.innerHTML = orig; addBtn.disabled = false; }, 1400);
      openCart();
    } else {
      addBtn.disabled = false;
    }
  });
})();

/* === Filter buttons === */
(function productFilters(){
  function applyLimit(target){
    const grid = document.querySelector(target || '#productGrid');
    if (!grid) return;
    const limit = matchMedia('(max-width: 700px)').matches
      ? parseInt(grid.dataset.mobileLimit || '4', 10)
      : parseInt(grid.dataset.desktopLimit || '6', 10);
    let shown = 0;
    grid.querySelectorAll('.product').forEach(p => {
      p.classList.remove('is-limit-hidden');
      if (p.classList.contains('is-filter-hidden')) return;
      shown += 1;
      if (shown > limit) p.classList.add('is-limit-hidden');
    });
  }

  document.querySelectorAll('#collectionFilters .filter, [data-filter-group] .filter').forEach(f => {
    f.addEventListener('click', () => {
      if (f.tagName === 'A' && f.getAttribute('href')) return;
      const group = f.closest('[data-filter-group]') || document.getElementById('collectionFilters');
      if (!group) return;
      group.querySelectorAll('.filter').forEach(x => x.classList.remove('active'));
      f.classList.add('active');
      const k = f.dataset.filter || 'all';
      const target = group.dataset.filterTarget || '#productGrid';
      document.querySelectorAll(target + ' .product').forEach(p => {
        const cols = (p.dataset.col || '').split(/\s+/);
        const show = (k === 'all') || cols.includes(k) || (p.dataset.subcol === k);
        p.classList.toggle('is-filter-hidden', !show);
        p.classList.toggle('is-hidden', !show);
      });
      const collectionUrl = f.dataset.collectionUrl;
      const footLink = document.querySelector('.collection-foot .btn');
      if (footLink && collectionUrl) footLink.href = collectionUrl;
      applyLimit(target);
    });
  });

  applyLimit('#productGrid');
  window.addEventListener('resize', () => applyLimit('#productGrid'));
})();

/* === Predictive search (nav) === */
(function navSuggest(){
  const input = document.getElementById('navSearchInput');
  const sug = document.getElementById('navSearchSuggest');
  if (!input || !sug) return;
  let timer = null;
  function render(html){ sug.innerHTML = html; sug.hidden = !html; }
  async function fetchSuggest(q){
    if (!q || q.trim().length < 2) { render(''); return; }
    try {
      const url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6';
      const r = await fetch(url, { headers:{'Accept':'application/json'} });
      if (!r.ok) return;
      const data = await r.json();
      const products = (data.resources && data.resources.results && data.resources.results.products) || [];
      if (!products.length) { render(''); return; }
      const html = products.map(p => {
        const img = p.featured_image && p.featured_image.url ? `background:url(${p.featured_image.url}) center/cover` : 'background:#FF7A1A';
        const title = (p.title || '').replace(/^Kalos · /,'').replace(/^Aloha Sun · /,'');
        const price = p.price ? '$' + (parseFloat(p.price)).toFixed(2) : '';
        return `<a class="nss-item" href="${p.url}" data-cursor="fruit">
          <span class="nss-sw" style="${img}"></span>
          <span class="nss-text"><b>${title}</b><span class="nss-meta">${p.vendor || ''} · ${price}</span></span>
        </a>`;
      }).join('') + `<a class="nss-all" href="/search?q=${encodeURIComponent(q)}">See all results →</a>`;
      render(html);
    } catch(e){ render(''); }
  }
  input.addEventListener('input', e => { clearTimeout(timer); timer = setTimeout(() => fetchSuggest(e.target.value), 180); });
  input.addEventListener('focus', e => { if (e.target.value) fetchSuggest(e.target.value); });
  document.addEventListener('click', e => { if (!sug.contains(e.target) && e.target !== input) sug.hidden = true; });
})();

/* === Search overlay (kept for keyboard / icon) === */
(function searchInit(){
  const ov = document.getElementById('searchOverlay');
  const open = document.getElementById('openSearch');
  const input = document.getElementById('searchInput');
  if (!ov) return;
  if (open) open.addEventListener('click', () => { ov.classList.add('open'); setTimeout(() => input && input.focus(), 50); });
  ov.addEventListener('click', (e) => { if (e.target === ov) ov.classList.remove('open'); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') ov.classList.remove('open');
    if ((e.key === '/' || (e.key === 'k' && (e.ctrlKey || e.metaKey))) && !ov.classList.contains('open')) {
      const tag = (document.activeElement && document.activeElement.tagName) || '';
      if (tag === 'INPUT' || tag === 'TEXTAREA') return;
      e.preventDefault(); ov.classList.add('open'); setTimeout(() => input && input.focus(), 50);
    }
  });
})();

/* === Shop dropdown tap fallback === */
(function navDropdown(){
  const nav = document.querySelector('.nav');
  const toggle = document.getElementById('navMenuToggle');
  if (nav && toggle) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('nav-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && nav.classList.contains('nav-open')) {
        nav.classList.remove('nav-open');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  }
  document.querySelectorAll('.nav-item .nav-trigger').forEach(t => {
    t.addEventListener('click', (e) => {
      if (!matchMedia('(max-width: 1024px)').matches) return;
      const item = t.closest('.nav-item');
      item.classList.toggle('open');
      e.stopPropagation();
    });
  });
  document.addEventListener('click', () => {
    document.querySelectorAll('.nav-item.open').forEach(i => i.classList.remove('open'));
  });
})();

/* === Pouch banner parallax === */
(function pouchBanner(){
  const hoverTargets = document.querySelectorAll('.pouch-banner-inner, .cat-tile, .product .vis');
  hoverTargets.forEach(el => el.addEventListener('mousemove', e => {
    const r = el.getBoundingClientRect();
    el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100) + '%');
    el.style.setProperty('--my', ((e.clientY - r.top)  / r.height * 100) + '%');
  }));
})();

/* === Hero image hydration === */
(function(){
  const stage = document.getElementById('stage');
  const img = document.getElementById('heroImg');
  if(!stage || !img) return;
  if (img.getAttribute('src')) { stage.classList.add('has-hero-image'); return; }
  const url = (window.HERO_IMAGE_URL || '').trim();
  if (url) { img.src = url; stage.classList.add('has-hero-image'); }
})();

document.querySelectorAll('[data-discount-form]').forEach(form => {
  form.addEventListener('submit', e => {
    e.preventDefault();
    const input = form.querySelector('input[name="discount"]');
    const code = input && input.value ? input.value.trim() : '';
    if (!code) return;
    window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
  });
});

/* =========================================================
   CATCH THE SUN — mini-game
   ========================================================= */
(function gameInit(){
  const stage = document.getElementById('gameStage');
  const canvas = document.getElementById('gameCanvas');
  const fruitLayer = document.getElementById('fruitLayer');
  const basket = document.getElementById('basket');
  const hudScore = document.getElementById('hudScore');
  const hudLives = document.getElementById('hudLives');
  const hudTarget = document.getElementById('hudTarget');
  const startBtn = document.getElementById('startBtn');
  const retryBtn = document.getElementById('retryBtn');
  const playAgain = document.getElementById('playAgain');
  const couponBtn = document.getElementById('couponBtn');
  const couponCode = document.getElementById('couponCode');
  const couponCopy = document.getElementById('couponCopy');
  const lostScore = document.getElementById('lostScore');
  const lostTarget = document.getElementById('lostTarget');
  const overlayWon = document.getElementById('overlayWon');
  if (!stage || !canvas || !fruitLayer || !basket || !hudScore || !hudLives || !hudTarget || !startBtn || !retryBtn || !playAgain || !couponBtn || !couponCode || !couponCopy || !lostScore || !lostTarget || !overlayWon) return;
  const wonHeadline = overlayWon.querySelector('.won-headline');
  const wonSub = overlayWon.querySelector('.won-sub');
  const wonFine = document.getElementById('wonFine');
  const wonCta = document.getElementById('wonCta');

  const TARGET = 500;
  const MAX_LIVES = 3;
  hudTarget.textContent = TARGET;
  lostTarget.textContent = TARGET;

  // SVG fruit graphics
  const FRUIT_SVG = {
    pine:   '<svg viewBox="0 0 60 70"><g><path d="M30 4 L24 14 L30 12 L36 14 Z" fill="#3a8a3a"/><path d="M22 10 L16 22 L26 18 Z M38 10 L44 22 L34 18 Z M30 12 L24 24 L30 22 L36 24 Z" fill="#4caf50"/><ellipse cx="30" cy="42" rx="20" ry="24" fill="#FFC93C"/><ellipse cx="30" cy="42" rx="20" ry="24" fill="url(#pineG)" opacity=".5"/><defs><radialGradient id="pineG" cx=".35" cy=".3"><stop offset="0" stop-color="#FFE680"/><stop offset="1" stop-color="#B88800"/></radialGradient></defs><g stroke="#8B5E1A" stroke-width="1" fill="none" opacity=".6"><path d="M16 28 L44 56 M44 28 L16 56 M22 22 L38 22 M22 62 L38 62"/></g></g></svg>',
    mango:  '<svg viewBox="0 0 60 60"><ellipse cx="30" cy="34" rx="22" ry="20" fill="#FF7A1A" transform="rotate(-15 30 34)"/><ellipse cx="24" cy="26" rx="14" ry="10" fill="#FFB370" opacity=".7" transform="rotate(-15 24 26)"/><path d="M40 12 Q44 8 48 14" stroke="#3a6b1f" stroke-width="2" fill="none"/><ellipse cx="42" cy="14" rx="3" ry="5" fill="#4caf50" transform="rotate(30 42 14)"/></svg>',
    papaya: '<svg viewBox="0 0 60 60"><ellipse cx="30" cy="36" rx="18" ry="22" fill="#FF8847"/><ellipse cx="26" cy="28" rx="10" ry="12" fill="#FFB58B" opacity=".7"/><path d="M30 14 L28 8 L32 8 Z" fill="#3a6b1f"/><circle cx="30" cy="40" r="2" fill="#4a1a0a" opacity=".5"/><circle cx="34" cy="44" r="1.5" fill="#4a1a0a" opacity=".5"/><circle cx="26" cy="44" r="1.5" fill="#4a1a0a" opacity=".5"/></svg>',
    guava:  '<svg viewBox="0 0 60 60"><circle cx="30" cy="34" r="22" fill="#FF4D8B"/><circle cx="24" cy="28" r="10" fill="#FF8FB3" opacity=".6"/><path d="M30 12 L26 6 L34 6 Z M30 12 L24 8 M30 12 L36 8" stroke="#3a6b1f" stroke-width="1.5" fill="#3a6b1f"/><ellipse cx="22" cy="10" rx="4" ry="2" fill="#4caf50"/><ellipse cx="38" cy="10" rx="4" ry="2" fill="#4caf50"/></svg>',
    liliko: '<svg viewBox="0 0 60 60"><circle cx="30" cy="34" r="21" fill="#A05CE0"/><circle cx="30" cy="34" r="21" fill="url(#lilG)" opacity=".6"/><defs><radialGradient id="lilG" cx=".35" cy=".3"><stop offset="0" stop-color="#E0C0F8"/><stop offset="1" stop-color="#5C2E92"/></radialGradient></defs><circle cx="24" cy="28" r="8" fill="#E0C0F8" opacity=".4"/><path d="M30 13 L28 8 L32 8 Z" fill="#3a6b1f"/></svg>',
    gold:   '<svg viewBox="0 0 60 60"><circle cx="30" cy="30" r="22" fill="#FFD60A"/><circle cx="30" cy="30" r="22" fill="url(#gldG)"/><defs><radialGradient id="gldG" cx=".35" cy=".3"><stop offset="0" stop-color="#FFF7CC"/><stop offset=".6" stop-color="#FFD60A" stop-opacity="0"/><stop offset="1" stop-color="#B88800"/></radialGradient></defs><g stroke="#FFF7CC" stroke-width="2" stroke-linecap="round"><line x1="30" y1="2" x2="30" y2="8"/><line x1="30" y1="52" x2="30" y2="58"/><line x1="2" y1="30" x2="8" y2="30"/><line x1="52" y1="30" x2="58" y2="30"/><line x1="10" y1="10" x2="14" y2="14"/><line x1="46" y1="46" x2="50" y2="50"/><line x1="10" y1="50" x2="14" y2="46"/><line x1="46" y1="14" x2="50" y2="10"/></g></svg>',
    coco:   '<svg viewBox="0 0 60 64"><ellipse cx="30" cy="36" rx="22" ry="24" fill="#5a3520"/><ellipse cx="30" cy="36" rx="22" ry="24" fill="url(#cocoG)"/><defs><radialGradient id="cocoG" cx=".35" cy=".3"><stop offset="0" stop-color="#8B5E34"/><stop offset=".6" stop-color="#5a3520" stop-opacity="0"/><stop offset="1" stop-color="#1F0E05"/></radialGradient></defs><g stroke="#3a1f10" stroke-width="1" opacity=".5" fill="none"><path d="M14 28 Q30 22 46 28 M14 36 Q30 30 46 36 M14 44 Q30 38 46 44"/></g><circle cx="22" cy="22" r="2" fill="#1F0E05"/><circle cx="30" cy="20" r="2" fill="#1F0E05"/><circle cx="38" cy="22" r="2" fill="#1F0E05"/><path d="M28 8 Q30 4 32 8" stroke="#3a6b1f" stroke-width="2" fill="none"/></svg>'
  };

  // --- Apply editable winning settings ---
  function applyWonSettings() {
    const head = overlayWon.dataset.headline || "You caught the sun.";
    // Italicize the last 2 words (e.g. "the sun.")
    const words = head.split(' ');
    if (words.length >= 2) {
      const last = words.slice(-2).join(' ');
      const rest = words.slice(0, -2).join(' ');
      wonHeadline.innerHTML = (rest ? rest + ' ' : '') + '<i>' + last + '</i>';
    } else {
      wonHeadline.innerHTML = '<i>' + head + '</i>';
    }
    wonSub.textContent = overlayWon.dataset.subhead || '';
    couponCode.textContent = overlayWon.dataset.code || 'ALOHA15';
    wonFine.textContent = overlayWon.dataset.fineprint || '';
    wonCta.innerHTML = (overlayWon.dataset.cta || 'Shop now') + ' <span class="arrow">→</span>';
    wonCta.setAttribute('href', overlayWon.dataset.ctaUrl || '#collection');
  }
  applyWonSettings();

  // Inject real SVG fruits into the How-to-Play rules list
  document.querySelectorAll('.rules .r-svg').forEach(el => {
    const fruit = el.dataset.fruit;
    if (FRUIT_SVG[fruit]) el.innerHTML = FRUIT_SVG[fruit];
  });

  // --- Game state ---
  let running = false;
  let score = 0;
  let basketX = 0.5;     // 0..1 of canvas width
  let basketWidthRatio = 0;
  let lastTs = 0;
  let spawnTimer = 0;
  let timerTimer = 0;
  let fruits = [];       // {el, x, y, vy, type, val}
  let rafId = null;
  let canvasRect = null;

  function recalcBounds() {
    canvasRect = canvas.getBoundingClientRect();
    basketWidthRatio = basket.offsetWidth / canvasRect.width;
  }

  function setBasketPos(x) {
    const half = basketWidthRatio / 2;
    basketX = Math.max(half, Math.min(1 - half, x));
    basket.style.left = (basketX * 100) + '%';
  }

  // --- Input: keyboard ---
  const keys = { left: false, right: false };
  window.addEventListener('keydown', (e) => {
    if (!running) return;
    if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') keys.left = true;
    if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') keys.right = true;
  });
  window.addEventListener('keyup', (e) => {
    if (e.key === 'ArrowLeft' || e.key === 'a' || e.key === 'A') keys.left = false;
    if (e.key === 'ArrowRight' || e.key === 'd' || e.key === 'D') keys.right = false;
  });

  // --- Input: pointer (mouse + touch) ---
  function pointerMove(clientX) {
    if (!running || !canvasRect) return;
    const x = (clientX - canvasRect.left) / canvasRect.width;
    setBasketPos(x);
  }
  canvas.addEventListener('mousemove', (e) => { if (running) { recalcBounds(); pointerMove(e.clientX); } });
  canvas.addEventListener('touchstart', (e) => {
    if (!running) return;
    recalcBounds();
    e.preventDefault();
    pointerMove(e.touches[0].clientX);
  }, { passive: false });
  canvas.addEventListener('touchmove', (e) => {
    if (!running) return;
    e.preventDefault();
    pointerMove(e.touches[0].clientX);
  }, { passive: false });

  // --- Spawning ---
  // Tuned for ~2 min average playtime to 500 points.
  // Average per-fruit value ~16; ramp is gentle so early game is forgiving.
  const FRUIT_TYPES = [
    { type: 'pine',   val: 10, weight: 24 },
    { type: 'mango',  val: 15, weight: 22 },
    { type: 'papaya', val: 15, weight: 18 },
    { type: 'guava',  val: 20, weight: 14 },
    { type: 'liliko', val: 25, weight: 10 },
    { type: 'gold',   val: 50, weight: 1.2, fast: true },   // rare AND fast
    { type: 'coco',   val: 0,  weight: 16, danger: true },
  ];
  function pickFruit() {
    const total = FRUIT_TYPES.reduce((s,f) => s + f.weight, 0);
    let r = Math.random() * total;
    for (const f of FRUIT_TYPES) {
      r -= f.weight;
      if (r <= 0) return f;
    }
    return FRUIT_TYPES[0];
  }
  let elapsed = 0;
  function spawnFruit() {
    const f = pickFruit();
    const el = document.createElement('div');
    el.className = 'fruit f-' + f.type;
    el.innerHTML = FRUIT_SVG[f.type] || '';
    const w = canvasRect ? canvasRect.width : 600;
    const fruitW = f.type === 'gold' ? 56 : (f.type === 'coco' ? 52 : 48);
    const x = Math.random() * (w - fruitW - 20) + 10;
    el.style.width = fruitW + 'px';
    el.style.height = (f.type === 'coco' ? 56 : fruitW) + 'px';
    el.style.left = x + 'px';
    el.style.top = '-70px';
    fruitLayer.appendChild(el);
    // Slow gentle ramp over ~2 minutes (cap ramp at 90s).
    const baseSpeed = 170 + Math.min(elapsed, 90) * 1.6;
    let vy = baseSpeed + Math.random() * 70;
    if (f.fast) vy *= 1.9; // golden sun falls fast
    fruits.push({ el, x, y: -70, vy, type: f.type, val: f.val, danger: !!f.danger, w: fruitW, h: (f.type === 'coco' ? 56 : fruitW) });
  }

  function popScore(text, x, y, cls) {
    const p = document.createElement('div');
    p.className = 'score-pop ' + (cls || '');
    p.textContent = text;
    p.style.left = x + 'px';
    p.style.top = y + 'px';
    fruitLayer.appendChild(p);
    setTimeout(() => p.remove(), 700);
  }

  function popLife(x, y) {
    const p = document.createElement('div');
    p.className = 'life-pop';
    p.textContent = '— 1 life';
    p.style.left = x + 'px';
    p.style.top = y + 'px';
    fruitLayer.appendChild(p);
    setTimeout(() => p.remove(), 800);
  }

  function loseLife(x, y) {
    lives -= 1;
    hudLives.textContent = '♥'.repeat(Math.max(0, lives)) + '♡'.repeat(MAX_LIVES - Math.max(0, lives));
    popLife(x, y);
    if (lives <= 0) endGame();
  }

  // --- Main loop ---
  function tick(ts) {
    if (!running) return;
    if (!lastTs) lastTs = ts;
    const dt = Math.min(0.05, (ts - lastTs) / 1000);
    lastTs = ts;
    elapsed += dt;

    const speed = 1.8;
    if (keys.left) setBasketPos(basketX - speed * dt);
    if (keys.right) setBasketPos(basketX + speed * dt);

    spawnTimer += dt;
    // Slow spawn ramp — starts ~1.0s, settles around ~0.55s after 90s.
    const spawnRate = Math.max(0.55, 1.0 - elapsed * 0.005);
    if (spawnTimer >= spawnRate) {
      spawnTimer = 0;
      spawnFruit();
    }

    if (!canvasRect) recalcBounds();
    const groundY = canvasRect.height - 60;
    const basketLeftPx = basketX * canvasRect.width - basket.offsetWidth / 2;
    const basketRightPx = basketLeftPx + basket.offsetWidth;
    const basketTopPx = canvasRect.height - basket.offsetHeight - 30;
    const catchTopPx = basketTopPx + 4;
    const catchBottomPx = basketTopPx + 30;

    for (let i = fruits.length - 1; i >= 0; i--) {
      const fr = fruits[i];
      fr.y += fr.vy * dt;
      fr.el.style.top = fr.y + 'px';

      const fruitCenterX = fr.x + fr.w / 2;
      const fruitBottomY = fr.y + fr.h;

      if (fruitBottomY >= catchTopPx && fruitBottomY <= catchBottomPx + 14 &&
          fruitCenterX >= basketLeftPx && fruitCenterX <= basketRightPx) {
        if (fr.danger) {
          // Caught coconut — lose a life
          fr.el.classList.add('caught');
          setTimeout(() => fr.el.remove(), 300);
          fruits.splice(i, 1);
          loseLife(fruitCenterX, basketTopPx - 10);
          if (!running) return;
        } else {
          score += fr.val;
          hudScore.textContent = score;
          const cls = fr.type === 'gold' ? 'gold' : '';
          popScore('+' + fr.val, fruitCenterX, basketTopPx, cls);
          fr.el.classList.add('caught');
          setTimeout(() => fr.el.remove(), 300);
          fruits.splice(i, 1);
          if (score >= TARGET) { winGame(); return; }
        }
        continue;
      }

      if (fr.y > groundY) {
        const cx = fruitCenterX;
        fr.el.remove();
        fruits.splice(i, 1);
        // Missed a GOOD fruit = lose a life. Coconut hitting ground = safe.
        if (!fr.danger) {
          loseLife(cx, groundY - 30);
          if (!running) return;
        }
      }
    }

    rafId = requestAnimationFrame(tick);
  }

  let lives = MAX_LIVES;
  function startGame() {
    score = 0;
    lives = MAX_LIVES;
    elapsed = 0;
    fruits.forEach(f => f.el.remove());
    fruits = [];
    fruitLayer.innerHTML = '';
    hudScore.textContent = '0';
    hudLives.textContent = '♥'.repeat(MAX_LIVES);
    stage.dataset.state = 'playing';
    running = true;
    lastTs = 0;
    spawnTimer = 0;
    timerTimer = 0;
    recalcBounds();
    setBasketPos(0.5);
    rafId = requestAnimationFrame(tick);
  }

  function endGame() {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
    fruits.forEach(f => f.el.remove());
    fruits = [];
    lostScore.textContent = score;
    stage.dataset.state = 'lost';
  }

  function winGame() {
    running = false;
    if (rafId) cancelAnimationFrame(rafId);
    fruits.forEach(f => f.el.remove());
    fruits = [];
    applyWonSettings();
    stage.dataset.state = 'won';
  }

  startBtn.addEventListener('click', startGame);
  retryBtn.addEventListener('click', startGame);
  playAgain.addEventListener('click', startGame);

  // Coupon copy
  couponBtn.addEventListener('click', () => {
    const code = couponCode.textContent;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(code).catch(()=>{});
    } else {
      const r = document.createRange();
      r.selectNode(couponCode);
      const sel = window.getSelection();
      sel.removeAllRanges();
      sel.addRange(r);
      try { document.execCommand('copy'); } catch(e) {}
      sel.removeAllRanges();
    }
    couponBtn.classList.add('copied');
    couponCopy.textContent = 'Copied ✓';
    setTimeout(() => {
      couponBtn.classList.remove('copied');
      couponCopy.textContent = 'Tap to copy';
    }, 1800);
  });

  window.addEventListener('resize', () => {
    recalcBounds();
    setBasketPos(basketX);
  });
  recalcBounds();
})();
